<template>
  <div class="gallery-container">
    <div class="gallery" ref="gallery">
      <div
        v-for="(item, index) in filteredGalleryData"
        :key="index"
        class="item"
        :style="{
          top: itemPositions[index].top,
          left: itemPositions[index].left,
          width: `${item.size * 200}px`,
          height: `${item.size * 235}px`,
        }"
      >
        <img :src="item.img" alt="Gallery Item" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import gsap from "gsap";
import { gallery as galleryDataRaw } from "@/data/data";

const gallery = ref(null);
const breakpoint = 768;

const galleryData = galleryDataRaw.map((item, index) => ({
  ...item,
  size: [1, 1.2, 1.0, 1.2, 0.9, 1.1, 1.1, 0.9][index],
}));

const filteredGalleryData = ref([...galleryData]);

const itemPositions = [
  { top: "5vh", left: "5vw" },
  { top: "15vh", left: "70vw" },
  { top: "25vh", left: "30vw" },
  { top: "40vh", left: "10vw" },
  { top: "50vh", left: "75vw" },
  { top: "65vh", left: "45vw" },
  { top: "75vh", left: "20vw" },
  { top: "85vh", left: "85vw" },
];

const updateGalleryByBreakpoint = () => {
  const width = window.innerWidth;

  if (width < breakpoint) {
    const indicesToRemove = [1, 3];
    filteredGalleryData.value = galleryData.filter(
      (_, index) => !indicesToRemove.includes(index)
    );
  } else {
    filteredGalleryData.value = [...galleryData];
  }
};

onMounted(() => {
  updateGalleryByBreakpoint(); // check on mount
  window.addEventListener("resize", updateGalleryByBreakpoint);

  document.addEventListener("mousemove", (e) => {
    if (!gallery.value) return;

    const items = gallery.value.querySelectorAll(".item");

    items.forEach((item, index) => {
      const animationFactor =
        filteredGalleryData.value[index]?.parallaxSpeed || 1.05;
      const deltaX = (e.clientX - window.innerWidth / 2) * animationFactor;
      const deltaY = (e.clientY - window.innerHeight / 2) * animationFactor;

      gsap.to(item, { x: deltaX, y: deltaY, duration: 0.75 });
    });
  });
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateGalleryByBreakpoint);
});
</script>

<style scoped lang="scss">
.gallery-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  pointer-events: none;
  z-index: 0;
  .gallery {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .item {
    position: absolute;
    width: 15vw;
    max-width: 320px;
    height: auto;
    @media (max-width: 768px) {
      width: 20vw;
      max-width: 180px;
      height: auto;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.75;
    border-radius: 10px;
    @media (max-width: 768px) {
      width: 80%;
      height: 50%;
    }
  }
}
</style>
